/**
 * assets/combined-pdp.js
 *
 * MODO ACTUAL (OPERATIVO): SOLO RELOAD
 * - Ante cualquier cambio de variante o cambio de producto hijo (Combined Listings),
 *   construye la URL final (respetando /collections/{handle}/products/... cuando aplica)
 *   y hace UN ÚNICO reload controlado.
 *
 * ANDAMIAJE (COMENTADO): SOFT-SWAP
 * - Se conserva abajo, totalmente desactivado, para una futura migración a swaps idempotentes.
 */
(function () {
  // =========================
  // ==== Reload helpers  ====
  // =========================
  const PDP_RELOAD_KEY = 'pdp:hardReloadOnce';

  // Limpia el flag al cargar la página (permite futuros reloads únicos)
  document.addEventListener('DOMContentLoaded', () => {
    if (sessionStorage.getItem(PDP_RELOAD_KEY) === '1') {
      sessionStorage.removeItem(PDP_RELOAD_KEY);
    }
  });

  function hardReloadOnce(targetUrl, reason = 'pdp-reload') {
    // Evita recargas infinitas
    if (sessionStorage.getItem(PDP_RELOAD_KEY) === '1') return;
    sessionStorage.setItem(PDP_RELOAD_KEY, '1');

    if (targetUrl) {
      // No añadimos entrada extra al historial
      window.location.replace(targetUrl);
    } else {
      window.location.reload();
    }
  }

  // =========================
  // ====== Utilidades  ======
  // =========================
  const sameOrigin = (urlLike) => {
    try {
      return new URL(urlLike, window.location.origin).origin === window.location.origin;
    } catch {
      return false;
    }
  };

  const stripQuery = (u) => (u || '').split('?')[0].replace(/\/+$/, '');

  // --- Helpers within collection ---
  function getCurrentCollectionHandle() {
    // Detecta /collections/{handle}/products/{...}
    const m = window.location.pathname.match(/^\/collections\/([^/]+)\/products\//);
    return m ? m[1] : null;
  }

  function hasCollectionInPath(pathname) {
    return /^\/collections\/[^/]+\/products\//.test(pathname || '');
  }

  /**
   * Si venimos desde /collections/{handle}/products/...,
   * asegura que la nueva URL preserve esa ruta de colección.
   */
  function ensureWithinCollection(urlLike) {
    const coll = getCurrentCollectionHandle();
    if (!coll) return urlLike; // No estamos bajo /collections -> devolver tal cual

    try {
      const u = new URL(urlLike, window.location.origin);
      if (hasCollectionInPath(u.pathname)) return u.toString(); // Ya viene con /collections
      if (/^\/products\//.test(u.pathname)) {
        u.pathname = `/collections/${coll}${u.pathname}`;
        return u.toString();
      }
      return u.toString();
    } catch {
      // urlLike relativo
      if (hasCollectionInPath(urlLike) || !/^\/products\//.test(urlLike)) return urlLike;
      return `/collections/${coll}${urlLike}`;
    }
  }
  // --- Fin helpers within ---

  // =========================
  // ====== Core (reload) ====
  // =========================
  function handleVariantChange(ev) {
    // Disparamos solo desde los radios de variante del PDP principal
    const input = ev.target?.closest('input[data-connected-product-url]');
    if (!input) return;

    const picker = input.closest('variant-radios[data-template-product-match="true"]');
    if (!picker) return;

    // Datos del input
    const connectedRaw  = input.dataset.connectedProductUrl || ''; // URL del hijo (si es cambio de color a hermano)
    const connectedPath = connectedRaw.split('?')[0];
    const variantId     = input.dataset.variantId || '';          // id de variante de destino (si lo tenemos)

    const baseProductUrl   = (picker.dataset.productUrl || window.location.pathname).split('?')[0];
    const willChangeProduct = connectedPath && stripQuery(connectedPath) !== stripQuery(baseProductUrl);

    if (willChangeProduct) {
      // Prevent VariantSelects.onVariantChange from running and flashing unavailable state
      //console.log('[Combined PDP] Navigación a producto hijo: previniendo UI updates innecesarios');
      ev.stopImmediatePropagation();
    }

    let targetUrl;

    if (willChangeProduct) {
      // Cambio a OTRO producto hijo
      targetUrl = variantId ? `${connectedPath}?variant=${variantId}` : connectedPath;
      targetUrl = ensureWithinCollection(targetUrl);
    } else {
      // Misma ficha: solo cambiamos la variante
      const u = new URL(window.location.href);
      if (variantId) u.searchParams.set('variant', variantId);
      else u.searchParams.delete('variant');
      targetUrl = ensureWithinCollection(u.toString());
    }

    if (!sameOrigin(targetUrl)) {
      // Seguridad: si llegara a ser cross-origin, navega “duro”
      window.location.assign(targetUrl);
      return;
    }

    // Modo actual: SIEMPRE reload único
    hardReloadOnce(targetUrl, willChangeProduct ? 'child-product-change' : 'same-product-variant');
  }

  // Capture phase: runs before VariantSelects.onVariantChange (bubble phase) so we can
  // call stopImmediatePropagation() for cross-product navigations before any UI update.
  document.addEventListener('change', handleVariantChange, true);

  // ===========================================
  // === ANDAMIAJE SOFT-SWAP (DESACTIVADO) =====
  // ===========================================
  /*
  let aborter = null;

  async function fetchAndSwap(newUrl, pushState = false) {
    if (pushState) history.pushState({}, '', newUrl);
    else history.replaceState({}, '', newUrl);

    try {
      aborter?.abort();
      aborter = new AbortController();
      const res  = await fetch(newUrl, { signal: aborter.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const html = await res.text();
      const doc  = new DOMParser().parseFromString(html, 'text/html');

      const newMain  = doc.querySelector('main');
      const curMain  = document.querySelector('main');
      const newTitle = doc.querySelector('title');

      if (!newMain || !curMain) {
        // Fallback: si no es seguro el swap, usa reload único
        hardReloadOnce(newUrl, 'swap-fallback');
        return;
      }

      if (newTitle) document.title = newTitle.textContent;
      curMain.replaceWith(newMain);

      // Aquí re-inicializar módulos idempotentes si el tema lo soporta
      try { window.Shopify?.PaymentButton?.init?.(); } catch(_) {}
      try { window.theme?.init?.(); } catch(_) {}
    } catch (e) {
      window.location.assign(newUrl);
    }
  }

  // Si algún día activamos soft-swap, podríamos:
  // - usar fetchAndSwap(finalUrl, true|false) en lugar de hardReloadOnce(...)
  // - gestionar popstate:
  // window.addEventListener('popstate', () => {
  //   const finalUrl = ensureWithinCollection(window.location.href);
  //   fetchAndSwap(finalUrl, false);
  // });
  */
})();
